import React from "react";
import styled from "styled-components";
import PretendardText from "../pretendardText";

const DetailFormTitle = (props) => {
  const { children, ...restProps } = props;

  const renderChild = (child, index) => {
    if (typeof child !== "string") {
      return child;
    }

    const requiredText = child.match(/^(.*)\*(\s*)$/s);
    if (!requiredText) {
      return child;
    }

    return (
      <React.Fragment key={index}>
        {requiredText[1]}
        <RequiredMark aria-label="필수">*</RequiredMark>
        {requiredText[2]}
      </React.Fragment>
    );
  };

  return (
    <DetailFormTitleWrapper {...restProps}>
      {React.Children.map(children, renderChild)}
    </DetailFormTitleWrapper>
  );
};

export default DetailFormTitle;

const DetailFormTitleWrapper = styled(PretendardText).attrs((props) => {})`
  min-width: 200px;
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  color: #adb4ba;
`;

const RequiredMark = styled.span`
  margin-left: 2px;
  color: #e5484d;
`;
